import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-[13px] font-medium transition-colors focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[rgba(243,207,91,.45)] disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-[var(--ink)] text-[var(--surface)] hover:opacity-90",
        destructive:
          "bg-[var(--danger-bg)] text-[var(--danger-fg)] hover:opacity-90",
        outline:
          "bg-[var(--surface)] border border-[var(--control)] text-[var(--ink-2)] hover:bg-[var(--chip)]",
        secondary:
          "bg-[var(--chip)] text-[var(--ink-2)] hover:opacity-90",
        brand:
          "bg-[var(--brand)] text-[var(--on-brand)] hover:opacity-90",
        ghost: "text-[var(--ink-2)] hover:bg-[var(--chip)]",
        link: "text-[var(--ink)] underline-offset-4 hover:underline",
      },
      size: {
        default: "h-[42px] px-5",
        sm: "h-8 px-3 text-[12px]",
        lg: "h-[46px] px-7 text-sm",
        icon: "h-[38px] w-[38px]",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
